export default __webpack_public_path__ + "static/media/bitkeep.de96e289.jpeg";